export default __webpack_public_path__ + "locales/fr/Settings.json?hash=bada7d8d96baa7e42e871b349a1e4ae6";